module.exports = __webpack_public_path__ + "img/MD.50a24dae.svg";